import { render, staticRenderFns } from "./Emojis.vue?vue&type=template&id=2fd43ce9&scoped=true"
import script from "./Emojis.vue?vue&type=script&lang=js"
export * from "./Emojis.vue?vue&type=script&lang=js"
import style0 from "./Emojis.vue?vue&type=style&index=0&id=2fd43ce9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd43ce9",
  null
  
)

export default component.exports